import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#ff0000', // Red color
        },
        secondary: {
            main: '#007bff',
        },
    },
});

export default theme;